const Offices = {
  africa: {
    color: "orange",
    addy: [
      {
        country: "Nigeria, West Africa",
        address: [
          [
            "1st floor, Gafunk house,",
            "7, Afisman drive, Anifowose",
            "Ikeja, Lagos Nigeria",
          ],
          ["16, Ademola Adetokunbo Crescent,", "Wuse 2, Abuja Nigeria."],
        ],
      },
      {
        country: "South Africa",
        address: [
          [
            "Atrium on 5th Street, Sandton",
            "2196 Johannesburg (GT)",
            "South Africa",
          ],
        ],
      },
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
  antartica: {
    color: "cyan",
    addy: [
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
  asia: {
    color: "yellow",
    addy: [
      {
        country: "Dubia",
        address: [
          ["Level 3 One Central", "PO Box 9573 Dubai", "United Arab Emirates"],
        ],
      },
      {
        country: "China",
        address: [
          [
            "Beijing - Dongcheng",
            "Level 12 China Resources Building",
            "100005 Beijing",
            "China",
          ],
        ],
      },
      {
        country: "Hong Kong",
        address: [
          [
            "21/F, CMA Building, 64 Connaught Road Central",
            "Hong Kong",
            "Hong Kong",
          ],
        ],
      },
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
  australia: {
    color: "red",
    addy: [
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
  europe: {
    color: "blue",
    addy: [
      {
        country: "United Kingdom",
        address: [
          ["59, St.Martin's Lane", "London WC2n 4JS", "United Kingdom"],
        ],
      },
      {
        country: "Spain",
        address: [
          [
            "Carrer de Campoamor, 27, P 3-5",
            "12001 Castelló de la Plana",
            "CS",
            "Valencia",
          ],
        ],
      },
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
  "north america": {
    color: "green",
    addy: [
      {
        country: "United State",
        address: [
          ["201 E Center St #112", "Anaheim, CA 92805"],
          [
            "Kansas City",
            "4050 Pennsylvania Ave",
            "Kansas City, MO 64111-3041",
          ],
          [
            "New York office",
            "778 Morris Park Ave",
            "Bronx, NY 10462",
            "New York",
          ],
        ],
      },
      {
        country: "Canada",
        address: [["A-56 Mill St E", "Acton, ON L7J 1H3", "Canada"]],
      },
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
  "south america": {
    color: "purple",
    addy: [
      {
        country: "International call centers:",
        address: [
          [
            "Sales/billing/support Inquiries",
            "US: +1-714-408-1961",
            "UK: +44 203239 8280",
            "Nigeria: +2347034146435, +2347034146433",
          ],
        ],
      },
    ],
  },
};

export default Offices;
